// src/index.js
import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { AuthProvider } from "./context/AuthContext";
import { ProfilePrefetchProvider } from "./context/ProfilePrefetchContext";
import { BrowserRouter as Router } from "react-router-dom";
import { ConsentProvider } from "./context/ConsentContext";
import { FirstRunProvider } from "./context/FirstRunContext";

const Providers = ({ children }) => (
  <ConsentProvider>
    <AuthProvider>
      <Router>
        <ProfilePrefetchProvider>
          <FirstRunProvider>{children}</FirstRunProvider>
        </ProfilePrefetchProvider>
      </Router>
    </AuthProvider>
  </ConsentProvider>
);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "development") {
  reportWebVitals(console.log);
} else {
  reportWebVitals();
}
